import RootPage from "../RootPage";
import { getFieldCompanyId } from "shell/services/fieldCompanyService";
import localisations from "shell/localisation";
import { AddManagedProduct } from "domains/allocations/components/add-managed-product";

import { reactPlugin } from "app-insights";
import { useAuth0 } from "@auth0/auth0-react";
import { withAITracking } from "@microsoft/applicationinsights-react-js";

const ManageProductsPage = () => {
    const { user } = useAuth0();
    const fieldCompanyId = getFieldCompanyId(user);

    return (
        <RootPage header={localisations.pages.manageProducts.heading}>
            <AddManagedProduct fieldCompanyId={fieldCompanyId}></AddManagedProduct>
        </RootPage>
    );
};

export default withAITracking(reactPlugin, ManageProductsPage, "Manage Products Page");
